module.exports = {
      id: "vikatan-play-logo-red-usage",
      viewBox: "0 0 536.066 789.439",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#vikatan-play-logo-red",
      toString: function () {
        return this.url;
      }
    }